import { render, staticRenderFns } from "./itc-study-detail.vue?vue&type=template&id=500e40d3&scoped=true"
import script from "./itc-study-detail.vue?vue&type=script&lang=js"
export * from "./itc-study-detail.vue?vue&type=script&lang=js"
import style0 from "./itc-study-detail.vue?vue&type=style&index=0&id=500e40d3&prod&lang=scss&scoped=true"
import style1 from "./itc-study-detail.vue?vue&type=style&index=1&id=500e40d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e40d3",
  null
  
)

export default component.exports